import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import type { CustomRouteState } from '@alltrails/maps/redux/customRoute';
import type { MapState } from '@alltrails/maps/redux/reducer';
import type Context from '@alltrails/types/Context';

// The slices this package reads from the host app's store. `customRoute` is optional
// because hosts that only display a route (the trail page) don't register the slice.
export type PrintReduxState = {
  context: Context;
  customRoute?: CustomRouteState;
  map: MapState;
};

// Intended for use within the package only
export const useAppSelector: TypedUseSelectorHook<PrintReduxState> = selector => useSelector(selector, shallowEqual);

export const useAppDispatch = () => useDispatch();

export const useAppStore = () => useStore<PrintReduxState>();
